import { sectionLabels } from "../section-labels";
import { colorFields, dividerField, productCardStyleField, productLayoutField, } from "./_shared";
/**
 * All-products grid — locked. The full filterable product list. Sellers
 * cannot remove this from the homepage because it's the storefront's primary
 * commerce surface (and SEO-critical: it's where most product links are
 * crawled from).
 */
export const allProductsSchema = {
    type: "all-products",
    name: sectionLabels["all-products"],
    description: {
        ar: "الشبكة الرئيسية لكل منتجات المتجر مع شرائح تصفية حسب الفئة.",
        en: "The main product grid with category filter pills.",
    },
    // Unlocked: deletable + re-addable from the picker. Still criticalForSeo, so
    // it can't be hidden while present (delete it instead).
    criticalForSeo: true,
    maxPerTemplate: 1,
    availableOnTemplates: ["home"],
    settings: [
        productLayoutField(),
        productCardStyleField(),
        {
            id: "title",
            type: "text",
            i18n: true,
            label: { ar: "عنوان القسم", en: "Section title" },
            validate: { max: 60 },
            default: { ar: "كل المنتجات", en: "All products" },
        },
        {
            id: "showCategoryPills",
            type: "checkbox",
            label: {
                ar: "إظهار شرائح تصفية الفئات",
                en: "Show category filter pills",
            },
            default: true,
        },
        {
            id: "filterStyle",
            type: "select",
            label: { ar: "نمط شرائح التصفية", en: "Filter tabs style" },
            helpText: {
                ar: "شكل أزرار تصفية الفئات.",
                en: "Look of the category filter tabs.",
            },
            options: [
                { value: "pills", label: { ar: "شرائح", en: "Pills" } },
                { value: "outline", label: { ar: "محددة", en: "Outline" } },
                { value: "underline", label: { ar: "تحته خط", en: "Underline" } },
                { value: "minimal", label: { ar: "بسيط", en: "Minimal" } },
            ],
            default: "pills",
            showIf: { showCategoryPills: true },
        },
        {
            id: "productsPerPage",
            type: "range",
            label: { ar: "عدد المنتجات بالصفحة", en: "Products per page" },
            min: 12,
            max: 96,
            step: 12,
            default: 50,
        },
        {
            id: "productsPerRow",
            type: "range",
            label: { ar: "عدد المنتجات في الصف", en: "Products per row" },
            helpText: {
                ar: 'عدد المنتجات اللي تظهر في القسم ده قبل زر "عرض الكل".',
                en: "How many products to show before the View-all CTA.",
            },
            min: 1,
            max: 12,
            step: 1,
            default: 12,
        },
        {
            id: "columnsPerRow",
            type: "range",
            // Desktop-only: this sets the desktop column count; mobile auto-fits
            // (MOBILE_DEFAULTS pins mobile to 2). Tagged so the simple editor hides it
            // on the mobile/tablet tabs instead of showing a control the current
            // preview device doesn't visibly react to.
            appliesTo: ["desktop"],
            label: { ar: "عدد الأعمدة", en: "Columns per row" },
            helpText: {
                ar: "عدد الأعمدة على شاشات الكمبيوتر. الموبايل بيرتب نفسه تلقائيًا.",
                en: "Desktop columns. Mobile keeps its auto-fit layout.",
            },
            min: 2,
            max: 6,
            step: 1,
            default: 4,
            // A8: slider/list lay out their own way and ignore the column count.
            showIf: { variant: ["standard", "masonry", "featured"] },
        },
        {
            id: "headingLevel",
            type: "headingLevel",
            label: { ar: "مستوى العنوان", en: "Heading level" },
            default: 2,
        },
        dividerField(),
        ...colorFields(),
    ],
};
//# sourceMappingURL=all-products.js.map